import styles from './OffCanvasLayout.module.scss';
import Button from '../Button/ButtonComponent';
import { useRouter } from 'next/router';
import { ReactSVG } from 'react-svg';
import { dataResources } from '@portal-internet/core';
import { useRedl } from 'hooks/useRedl';
import { useRedlMetadata } from 'hooks/useRedlMetadata';
import OffCanvasBlockComponent from '../OffCanvasBloc';
import { useEffect, useRef } from 'react';
import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';

const { basePath } = dataResources;

export default function OffCanvasLayoutComponent({ ultimBloc }) {
    const router = useRouter();
    const ref = useRef(null);
    const scrollRef = useRef(null);
    const { getRedlPageMetadata, removeRenderThumbnail, getZonaEditable, getRedlPageRawLayout } = useRedlMetadata(router.pathname, router.query);
    const { unDoZoom, showLayout, setShowLayout, scrollPercentage } = useRedl();

    useEffect(() => {
        return autoScrollForElements({
            element: ref.current,
            canScroll: ({ source }) => source.data.type === 'thumbnail'
        });
    });

    const goToBlock = (blocIdx) => () => {
        document.getElementById(`blocredl-${blocIdx}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const pageMetadata = getRedlPageMetadata(router.pathname);
    const pageRawLayout = getRedlPageRawLayout(router.pathname)

    const getBlocs = (structure = []) => {
        if (structure.length === 0 ) return structure;
        let blocs = structure.find(s => s.name === 'ZonaEditable')?.children || [];
        if (blocs.length === 0) {
            blocs = structure.find(s => s.name === "Estructura")?.children?.find(s => s.name === 'ZonaEditable')?.children  || []

        }
        return blocs
    };

    const blocs = getBlocs(pageMetadata?.structure);
    const layoutsMetadata = getBlocs(pageRawLayout?.structure);
    const overlayPosition = Math.max(
        Math.min((
            scrollPercentage * scrollRef.current?.scrollHeight - 120) || 0,
            scrollRef.current?.scrollHeight - 240),
        0) || 0;

    return (
        <div className={`${styles.redlOffCanvasLayout} ${showLayout && styles.redlOffCanvasLayoutShow}`}
             style={{ zoom: `${unDoZoom}%` }}>
            <div className={styles.redlOffCanvasLayoutInnerHead}>
                <Button variant="tertiary" size="sm" onClick={() => setShowLayout(false)}>
                    <ReactSVG src={basePath + '/_resources/REDL/icons/x.svg?v=JIT_ENV_RESOURCES_VERSION'} />
                </Button>
            </div>
            <div className={styles.redlOffCanvasLayoutInnerBody} ref={ref}>
                <div className={styles.redlOffCanvasLayoutOverlay} style={{ top: overlayPosition }} />
                <ul className={styles.redlOffCanvasLayoutList} ref={scrollRef}>
                    {blocs.map((b, index ) => (
                        <OffCanvasBlockComponent 
                            key={b.blocIdx} 
                            block={b} 
                            ultimBloc={ultimBloc}
                            goToBlock={goToBlock} 
                            renderThumbnails={pageMetadata.renderThumbnails}
                            removeRenderThumbnail={removeRenderThumbnail}
                            layoutMetadataPath={layoutsMetadata[index]?.props?.path}

                        />
                    ))}
                </ul>
            </div>
        </div>
    );
}